import styled from 'styled-components';
import theme from "../../theme";

export const Container = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    .texts {
      h3 {
        font-size: 32px;
        line-height: 44px;
        color: #2b2f38;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #667085;
      }
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        a {
          text-decoration: none;
          color: #344054;
        }
      }
      .add-campaign {
        a {
          color: #fff;
        }
        border: 1px solid ${theme.color.brandDark};
        background-color: ${theme.color.brandDark};
      }
    }
  }
`;

export const LayoutContainer = styled.div`
margin-top: 20px;
	.active {
        padding: 8px 48px;
        border-radius: 24px;
        background-color: #E6F2F2;
		color: ${theme.color.brandDark};
	}
`;

export const TabContainer = styled.div`
	position: sticky;
	top: 0;
	background: #fff;
	z-index: 99;
`;

export const TabNavigationTab = styled.nav`
	padding: 15px 10px;
	overflow-x: scroll;

	ul {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}
	li {
		padding: 15px 2%;
        margin-right: 10px;
		display: inline;
		&:first-child {
			padding-left: 0;
		}
	}
	li a {
		color: #718096;
		padding: 14px 0;
		text-decoration: none;
	}
`;